import { useEffect, useRef, useState } from "react";

export const useStickyNav = () => {
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(([entry]) => setIsStuck(!entry.isIntersecting));
    observer.observe(sentinel);

    return () => observer.disconnect();
  }, []);

  return { isStuck, sentinelRef };
};
